import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatRadioChange} from "@angular/material/radio";
import {Order, OrderStatus} from "../../services/order.service";

@Component({
  templateUrl: './order-status-dialog.component.html',
  styleUrls: ['./order-status-dialog.component.css']
})
export class OrderStatusDialogComponent implements OnInit {

    newStatus: OrderStatus;
    sendEmail: boolean = false;

    constructor(private dialogRef: MatDialogRef<OrderStatusDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public order: Order) {
    }

    ngOnInit() {
    }

    statusChanged(ev: MatRadioChange) {
        this.newStatus = ev.value;
        this.sendEmail = false;
    }

    update() {
        this.dialogRef.close({
            newStatus: this.newStatus,
            sendEmail: this.sendEmail
        });
    }

    statusHasEmail(): boolean {
        const status: OrderStatus = this.newStatus || this.order.status;
        return ['processing', 'shipped', 'delivered'].includes(status);
    }
}
